export default function getDateFromQueryString() {
  var url = new URL(decodeURI(window.location.href));
  var search_params = url.searchParams;

  return {
    bot_id: search_params.get("bot_id"),
    trigger: search_params.get("trigger"),
    did_comeback: search_params.get("did_comeback"),
    client_url: search_params.get("client_url"),
    is_appearance: search_params.get("is_appearance"),
    conversion: search_params.get("conversion"),
    hide_header: search_params.get("hide_header"),
    national_id : search_params.get("national_id"),
    host : search_params.get("host"),
    host_route : search_params.get("host_route"),
  };
}
